import {Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {NavbarComponent} from './shared/components/nav-bar/nav-bar';
import {MobileHeaderComponent} from './shared/components/mobile-header-component/mobileHeaderComponent';
import {MobileNavService} from './shared/components/mobile-header-component/service/mobile-nav.service';
import {ModalCargaComponent} from './shared/components/modal-carga-component/modal-carga-component';
import {LoadingService} from './shared/services/loading.service';
import {AuthService} from './features/auth/services/auth.service';
import {ThemeService} from '@/app/core/services/theme/theme.service';
import {ITheme} from '@/themes/theme.interface';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NavbarComponent,
    MobileHeaderComponent,
    ModalCargaComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true,
})
export class App {
  nav = inject(MobileNavService);
  loadingService = inject(LoadingService);
  authService = inject(AuthService);
  private themeService = inject(ThemeService);

  get theme(): ITheme | null {
    return this.themeService.getTheme();
  }
}
